var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "yellow darken-3",
                    dense: "",
                    flat: "",
                    dark: ""
                  }
                },
                [
                  _c("span", [_vm._v("Edit")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", "x-small": "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.getPtCashVoucher()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-recycle")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          !_vm.changePayTo
                            ? _c("v-text-field", {
                                attrs: {
                                  label: "Pay to",
                                  disabled: !_vm.payTo,
                                  value: _vm.payToEntity.name,
                                  readonly: "",
                                  dense: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "prepend",
                                      fn: function() {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "primary--text" },
                                            [_vm._v(_vm._s(_vm.payToEntity.id))]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "append",
                                      fn: function() {
                                        return [
                                          _c(
                                            "base-tooltip",
                                            {
                                              attrs: {
                                                dark: "",
                                                bottom: "",
                                                tooltip: "Change Pay To",
                                                text: "",
                                                color: "yellow darken-2",
                                                "x-small": ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.changePayTo = true
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-pencil")
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  2415704348
                                )
                              })
                            : _c("v-autocomplete", {
                                attrs: {
                                  label: "Pay To",
                                  "search-input": _vm.payToSearch,
                                  "item-value": "id",
                                  "item-text": "name",
                                  items: _vm.voucherPayToList,
                                  loading: _vm.voucherPayToGetting,
                                  clearable: "",
                                  "no-filter": "",
                                  dense: ""
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    _vm.payToSearch = $event
                                  },
                                  "update:search-input": function($event) {
                                    _vm.payToSearch = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend",
                                    fn: function() {
                                      return [
                                        _c(
                                          "base-tooltip",
                                          {
                                            attrs: {
                                              dark: "",
                                              bottom: "",
                                              tooltip: "Cancel",
                                              text: "",
                                              color: "error",
                                              "x-small": ""
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.changePayTo = false
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("mdi-close")])],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "selection",
                                    fn: function({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "primary--text mr-2" },
                                          [_vm._v(_vm._s(item.id))]
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "blue-grey--text" },
                                          [
                                            _vm._v(
                                              _vm._s(item.name) +
                                                " (" +
                                                _vm._s(item.type) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "item",
                                    fn: function({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "primary--text mr-2" },
                                          [_vm._v(_vm._s(item.id))]
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "blue-grey--text" },
                                          [
                                            _vm._v(
                                              _vm._s(item.name) +
                                                " (" +
                                                _vm._s(item.type) +
                                                ")"
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.payTo,
                                  callback: function($$v) {
                                    _vm.payTo = $$v
                                  },
                                  expression: "payTo"
                                }
                              })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "PT Cash No",
                              disabled: "",
                              dense: "",
                              value: _vm.ptCashVoucherNumber
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Date", type: "date", dense: "" },
                            model: {
                              value: _vm.date,
                              callback: function($$v) {
                                _vm.date = $$v
                              },
                              expression: "date"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Address", dense: "" },
                            model: {
                              value: _vm.address,
                              callback: function($$v) {
                                _vm.address = $$v
                              },
                              expression: "address"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                dense: "",
                                dark: "",
                                color: "yellow darken-3",
                                loading: _vm.ptCashVuocherUpdatePosting
                              },
                              on: { click: _vm.updatePtCashData }
                            },
                            [_c("span", [_vm._v("Update")])]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                dense: "",
                                dark: "",
                                color: "error"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.go(-1)
                                }
                              }
                            },
                            [_c("span", [_vm._v("Cancel")])]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "purple", dense: "", flat: "", dark: "" } },
                [
                  _c("span", [_vm._v("Details")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green", dark: "", small: "", dense: "" },
                      on: {
                        click: function($event) {
                          _vm.createPtCashDetailDialog = true
                        }
                      }
                    },
                    [_c("span", [_vm._v("Add")])]
                  )
                ],
                1
              ),
              _c("v-simple-table", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Account Code")]),
                            _c("th", [_vm._v("Description")]),
                            _c("th", { staticClass: "text-right" }, [
                              _vm._v("Amount")
                            ])
                          ])
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.ptCashDetailList, function(item, index) {
                            return _c("tr", { key: index }, [
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "yellow darken-3",
                                        text: "",
                                        "x-small": ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.editPtCashDetail(item)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("mdi-pencil")])],
                                    1
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(item.account_code.account_code)
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.description))]),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(item.amount.phpFormat()))
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("edit-detail", {
        attrs: {
          edit: _vm.editPtCashDetailData,
          "account-codes": _vm.voucherAccountCodeList
        },
        on: {
          "update:edit": function($event) {
            _vm.editPtCashDetailData = $event
          }
        },
        model: {
          value: _vm.editPtCashDetailDialog,
          callback: function($$v) {
            _vm.editPtCashDetailDialog = $$v
          },
          expression: "editPtCashDetailDialog"
        }
      }),
      _c("create-detail", {
        attrs: { "account-codes": _vm.voucherAccountCodeList },
        model: {
          value: _vm.createPtCashDetailDialog,
          callback: function($$v) {
            _vm.createPtCashDetailDialog = $$v
          },
          expression: "createPtCashDetailDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }